import {
  combineReducers,
  configureStore,
} from '@reduxjs/toolkit'
import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import appSlice from 'common/store/appSlice'
import authSlice from 'features/auth/authSlice'
import clientSlice from 'features/admin/services/clientService/clientSlice'
import intakeFormSlice from 'features/client/services/intakeFormSlice';
import adminIntakeQuestions from 'features/admin/services/adminIntakeQuestions'
import { rtkQueryErrorHandler } from 'common/utils/rtkErrorHandler'
import { rtkQueryErrorLogger } from 'common/utils/rtkQueryErrorLogger'

import { baseApi } from 'common/store/baseApi'
import { azureStorageApi } from 'common/utils/azureStorageService/azureStorageAPI'
import { memberApi } from 'features/client/services/member'
import { helpPagesApi } from 'features/help/services/home'
import profileFormSlice from 'features/client/services/profileFormSlice'
import userSlice from 'features/client/services/userSlice'
import ffqSlice from 'features/client/services/ffqSlice'
import errorSlice from 'features/admin/utils/ErrorBoundary/errorSlice'
import modalsSlice from 'features/client/services/modalsSlice'
import homepagePreviewSlice from 'features/admin/services/homepagePreviewSlice'
import customizationSlice from 'features/admin/services/customization/customizationSlice'
import triggersSlice from 'features/client/services/triggersSlice'

export const rootReducer = combineReducers({
  app: appSlice,
  auth: authSlice,
  profileForm: profileFormSlice,
  modals: modalsSlice,
  user: userSlice,
  ffq: ffqSlice,
  triggers: triggersSlice,
  client: clientSlice,
  customization: customizationSlice,
  errors: errorSlice,
  intakeForm: intakeFormSlice,
  adminIntakeForm: adminIntakeQuestions,
  homepagePreview: homepagePreviewSlice,
  [baseApi.reducerPath]: baseApi.reducer,
  [azureStorageApi.reducerPath]: azureStorageApi.reducer,
  [memberApi.reducerPath]: memberApi.reducer,
  [helpPagesApi.reducerPath]: helpPagesApi.reducer,
});

const persistConfig = {
  key: 'root',
  version: 1,
  storage,
  blacklist: [
    memberApi.reducerPath,
    helpPagesApi.reducerPath,
    baseApi.reducerPath,
    azureStorageApi.reducerPath,
    'errors',
  ],
};

export const persistedReducer = persistReducer(persistConfig, rootReducer)

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }).concat(
      azureStorageApi.middleware,
      baseApi.middleware,
      memberApi.middleware,
      rtkQueryErrorHandler,
      rtkQueryErrorLogger,
    ),
})

export const persistor = persistStore(store)
export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
